function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  d: "M7.875 1.167a1.412 1.412 0 0 1 1.458 1.359V3.5h2.917a.583.583 0 1 1 0 1.167h-.583v6.416a1.75 1.75 0 0 1-1.75 1.75H4.083a1.75 1.75 0 0 1-1.75-1.75V4.667H1.75a.583.583 0 1 1 0-1.167h2.917v-.974a1.412 1.412 0 0 1 1.458-1.36zm2.625 3.5h-7v6.416l.008.095a.583.583 0 0 0 .575.489h5.834a.583.583 0 0 0 .583-.584V4.667zm-5.25 1.75c.322 0 .583.26.583.583v2.333a.583.583 0 0 1-.583.584l-.095-.008a.583.583 0 0 1-.488-.576V7c0-.322.26-.583.583-.583zm3.5 0c.322 0 .583.26.583.583v2.333a.583.583 0 0 1-.583.584l-.095-.008a.583.583 0 0 1-.488-.576V7c0-.322.26-.583.583-.583zm-.875-4.084h-1.75c-.17 0-.292.1-.292.193V3.5h2.334v-.974c0-.093-.123-.193-.292-.193z"
});

var SvgTrash = function SvgTrash(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTrash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trash.ca205cb9.svg";
export { ForwardRef as ReactComponent };